import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SortTypes } from '@share/constants';

const DEFAULT_CONDO_DISTANCE_IN_MILES = 20;

export interface IWeeksFiltersState {
  sortBy: SortTypes;

  propertyName: string;
  budgetRanges: string[];
  guestRatings: string[];
  distanceInMiles: number;
  unitAmenities: string[];
  facilities: string[];
  activities: string[];
  condoTypes: string[];
  policies: string[];
  accessibilities: string[];
  suppliers: string[];
  neighbourhoods: string[];
  places: string[];
  kitchenTypes: string[];
  bathrooms: number[];
  days: number[];
  months: number[];
  isAllInclusiveOnly: boolean;
}

export const WeeksFiltersInitialState: IWeeksFiltersState = {
  propertyName: '',
  budgetRanges: [],
  guestRatings: [],
  distanceInMiles: DEFAULT_CONDO_DISTANCE_IN_MILES,
  unitAmenities: [],
  facilities: [],
  activities: [],
  condoTypes: [],
  policies: [],
  accessibilities: [],
  suppliers: [],
  neighbourhoods: [],
  places: [],
  kitchenTypes: [],
  bathrooms: [],
  days: [],
  months: [],
  sortBy: SortTypes.BiggestSavingsPercentage,
  isAllInclusiveOnly: false,
};

const weeksFiltersSlice = createSlice({
  name: 'weeksFilters',
  initialState: WeeksFiltersInitialState,
  reducers: {
    setSortBy: (state: IWeeksFiltersState, { payload }: PayloadAction<SortTypes>) => {
      state.sortBy = payload;
    },
    setBudgetRanges: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.budgetRanges = payload;
    },
    setGuestRatings: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.guestRatings = payload;
    },
    setDistanceInMiles: (state: IWeeksFiltersState, { payload }: PayloadAction<number>) => {
      state.distanceInMiles = payload;
    },
    setUnitAmenities: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.unitAmenities = payload;
    },
    setFacilities: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.facilities = payload;
    },
    setActivities: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.activities = payload;
    },
    setCondoTypes: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.condoTypes = payload;
    },
    setPolicies: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.policies = payload;
    },
    setAccessibilities: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.accessibilities = payload;
    },
    setSuppliers: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.suppliers = payload;
    },
    setNeighbourhoods: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.neighbourhoods = payload;
    },
    setPlaces: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.places = payload;
    },
    setKitchenTypes: (state: IWeeksFiltersState, { payload }: PayloadAction<string[]>) => {
      state.kitchenTypes = payload;
    },
    setAllInclusive: (state: IWeeksFiltersState, { payload }: PayloadAction<boolean>) => {
      state.isAllInclusiveOnly = payload;
    },
    setBathrooms: (state: IWeeksFiltersState, { payload }: PayloadAction<number[]>) => {
      state.bathrooms = payload;
    },
    setDays: (state: IWeeksFiltersState, { payload }: PayloadAction<number[]>) => {
      state.days = payload;
    },
    setMonths: (state: IWeeksFiltersState, { payload }: PayloadAction<number[]>) => {
      state.months = payload;
    },
    setPropertyName: (state: IWeeksFiltersState, { payload }: PayloadAction<string>) => {
      state.propertyName = payload;
    },

    resetFilters: () => {
      return WeeksFiltersInitialState;
    },
    setFilters: (state: IWeeksFiltersState, { payload }: PayloadAction<IWeeksFiltersState>) => {
      return payload;
    },
  },
});

export const weeksFiltersActions = weeksFiltersSlice.actions;

export const weeksFiltersReducer = weeksFiltersSlice.reducer;
